import {DataApiCache} from '../api/Cache'

const baseURL = process.env.REACT_APP_PMI_API_BASE_URL;

export const COMPOUND = 'Compounds';
export const CANNABIS_COMPOUNDS = "Cannabis_Compounds";
export const AROMA = "Aroma";
export const REFERENCES = "References";
export const MARKET_CBD = "CBD_Market";
export const PHYSICAL_CHARACTERIZATION_CBD = "CBD_physical_characterization";
export const PHARMACO_DYNAMICS = "PharmacoDynamics";
export const MUTAGENICITY = 'Mutagenicity';
export const STABILITY = "Stability";
export const TOXICANTS_DISEASE = "Toxicants_Disease"

const _api = new DataApiCache();

export const getObjectByField = async (type: string, key: string, value: string) => {
    try{
        const address = `${baseURL}/compounds/${type}/${key}/${value}`;
        const data = await _api.get(address);
        return data;
    }
    catch(ex){
        throw new Error(`Failed to get compound data for ${type} - ${key} - ${value}`);
    }
};


export const getObjectByDoc = async (type: string, doc: any) => {
    try{
        const address = `${baseURL}/compounds/${type}/`;
        const data  = await _api.post(address, doc);
        return data;
    }
    catch(ex){
        throw new Error(`Failed to get compound data for ${type} `);
    }
};

export const getObjectsByRegEx = async (type: string, key: string, value: string) => {
    try{
        const address = `${baseURL}/compounds/${type}/regex`;
        const data = await _api.post(address, {
            field: key,
            pattern: value
        });
        return data;
    }
    catch(ex){
        throw new Error(`Failed to get compound data for ${type} - ${key} - ${value}`);
    }
};

export const getByFilters = async (type: string, filters: any[]) => {
    try{
            const address = `${baseURL}/compounds/${type}/byfilters/`;
            const data = await _api.post(address, {
                filters: filters
            });
            return data;

    }
    catch(ex:any){
        throw new Error(`Failed to get data compounds using filters:  ${filters} `);
    }
};


export const save = async (type: string, doc: any) => {
    try{
        const address = `${baseURL}/compounds/${type}/save`;
        const data  = await _api.post(address, doc);
        _api.clearCache();
        return data;
    }
    catch(ex){
        throw new Error(`Failed to save compound data for ${type} `);
    }
};

export const deleteDoc = async (type: string, doc: any) => {
    try{
        const address = `${baseURL}/compounds/${type}/delete/${doc._key}`;
        const data  = await _api.delete(address);
        _api.clearCache();
        return data;
    }
    catch(ex){
        throw new Error(`Failed to delete compound data for ${type} `);
    }
};

export const saveBulk = async (type: string, docs: any[]) => {
    try{
        const address = `${baseURL}/compounds/${type}/save/bulk`;
        const data  = await _api.post(address, docs);
        _api.clearCache();
        return data;
    }
    catch(ex){
        throw new Error(`Failed to save compound data for ${type} `);
    }
};

